<template>
    <i18n-t keypath="auth.recaptchaNotice" tag="p" class="recaptcha-notice">
        <template #privacy>
            <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
            >{{ $t('auth.recaptchaPrivacy') }}</a>
        </template>
        <template #terms>
            <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
            >{{ $t('auth.recaptchaTerms') }}</a>
        </template>
    </i18n-t>
</template>

<style scoped>
.recaptcha-notice {
    margin: 12px 0 0;
    font-size: 12px;
    line-height: 1.45;
    color: #6b7280;
    text-align: center;
}

.recaptcha-notice a {
    color: inherit;
    text-decoration: underline;
}
</style>
